// Vocabulaire commun des animations du site : UNE courbe, trois durées, des helpers purs.
// Toute apparition du site passe par ce fichier pour rester homogène (pas de rebond, sortie douce).

// Courbe de Bézier cubique « sortie rapide puis amortie » (proche d'easeOutQuint, sans dépassement).
export const EASE = [0.22, 1, 0.36, 1];

export const DUR = {
  fast: 0.18, // menus, survols
  base: 0.55, // apparitions au défilement
  slow: 0.9, // titre du hero
};

// Déclenchement des apparitions : une seule fois, quand l'élément est entré d'au moins 80 px dans l'écran.
export const VIEWPORT = { once: true, margin: '0px 0px -80px 0px' };

// Un groupe révèle ses enfants en cascade ; chaque enfant monte de 24 px en s'opacifiant.
export const revealGroup = {
  hidden: {},
  show: { transition: { staggerChildren: 0.08, delayChildren: 0.05 } },
};

export const revealItem = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: DUR.base, ease: EASE } },
};

/**
 * Découpe un titre en lignes (sur « \n ») puis en mots, sans lignes ni mots vides.
 * "Votre informatique.\nNotre expertise." → [["Votre","informatique."],["Notre","expertise."]]
 */
export function splitLines(text) {
  if (typeof text !== 'string' || !text) return [];
  return text
    .split('\n')
    .map((line) => line.trim().split(/\s+/).filter(Boolean))
    .filter((words) => words.length > 0);
}

/**
 * Répète une liste (dans l'ordre) jusqu'à atteindre `minCount` éléments : une bande de
 * défilement doit être plus large que son conteneur pour boucler sans trou.
 */
export function marqueeTrack(items, minCount = 12) {
  if (!Array.isArray(items) || items.length === 0) return [];
  const copies = Math.max(1, Math.ceil(minCount / items.length));
  const out = [];
  for (let i = 0; i < copies; i += 1) out.push(...items);
  return out;
}

/** Progression de lecture bornée dans [0, 1] ; NaN ou valeur absente → 0. */
export function clampProgress(value) {
  if (typeof value !== 'number' || Number.isNaN(value)) return 0;
  return Math.min(1, Math.max(0, value));
}
